import { Container, ContentContainer } from "@src/core/styles";
import type { FC } from "react";
import { ContentWrapper } from "../home-page/dashboard.styles";
import { TitleText, DescriptionText } from "../price-page/price-page.styles";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import {
  AccordionGroup,
  AccordionTitle,
  AccordionBody,
  HelperBlock,
} from "../price-page/components/questions/questions.styles";
import { ReactComponent as ExpandMoreIcon } from "@src/core/icons/expand-more.svg";
import { WrapContainer } from "../price-page/components/description/description.styles";
import { ReactComponent as HelpIcon } from "@src/core/icons/help.svg";
import { ServicePageInner } from "./service-page.styles";
import { Button } from "@src/components";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "@src/core/constants";

export const ServicePage: FC = () => {
  const navigate = useNavigate();

  const goToHelpForm = () => {
    navigate(APP_ROUTES.HELP);
  };
  return (
    <Container>
      <ContentContainer>
        <ContentWrapper>
          <ServicePageInner>
            <WrapContainer>
              <TitleText>Вопросы по работе сервиса</TitleText>
              <DescriptionText>
                У нас есть ответы на множество вопросов, и мы готовы помочь вам.
                Независимо от того, нужна ли вам помощь в использовании нашего
                сервиса, решении проблемы или получении дополнительной
                информации, мы здесь, чтобы поддержать вас. Просто задайте ваш
                вопрос, и мы постараемся предоставить вам исчерпывающий ответ в
                кратчайшие сроки. Ваше удовлетворение является нашим
                приоритетом, и мы с нетерпением ждем возможности помочь вам.
              </DescriptionText>
              <AccordionGroup>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion1"
                  >
                    <AccordionTitle>
                      Какие основные преимущества использования API для
                      тестирования?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Suspendisse malesuada lacus ex, sit amet blandit leo
                      lobortis eget.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion2"
                  >
                    <AccordionTitle>
                      Как я могу отправить запрос через API?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Suspendisse malesuada lacus ex, sit amet blandit leo
                      lobortis eget.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion3"
                  >
                    <AccordionTitle>
                      Как я могу получить ответ от API и проверить его на
                      соответствие ожидаемым результатам?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion4"
                  >
                    <AccordionTitle>
                      Какие типы аутентификации поддерживает ваш сервис для
                      API-тестирования?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion5"
                  >
                    <AccordionTitle>
                      Как можно автоматизировать тестирование API?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion6"
                  >
                    <AccordionTitle>
                      Можете ли вы предоставить пример кода для отправки запроса
                      через API?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion7"
                  >
                    <AccordionTitle>
                      Как можно обрабатывать ошибки или исключения, которые
                      могут возникнуть при тестировании API?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion8"
                  >
                    <AccordionTitle>
                      Как я могу проверить производительность API и определить
                      потенциальные узкие места?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion9"
                  >
                    <AccordionTitle>
                      Какие инструменты или библиотеки вы рекомендуете для
                      тестирования API?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="accordion10"
                  >
                    <AccordionTitle>
                      Как я могу создать надежные и повторяемые тестовые
                      сценарии для API?
                    </AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionBody>
                      Тестирование API может быть проведено на ранних стадиях
                      разработки, еще до создания пользовательского интерфейса.
                      Это позволяет выявить потенциальные проблемы и ошибки
                      взаимодействия между компонентами системы.
                    </AccordionBody>
                  </AccordionDetails>
                </Accordion>
              </AccordionGroup>
            </WrapContainer>
            <HelperBlock>
              <HelpIcon />
              <div>
                Задайте свой вопрос о работе сервиса, и мы с радостью
                предоставим вам необходимую информацию и помощь для максимально
                комфортного использования нашего сервиса
              </div>
              <Button
                text="Задать вопрос"
                borderradius="XXXL"
                variant="label"
                onClick={goToHelpForm}
              />
            </HelperBlock>
          </ServicePageInner>
        </ContentWrapper>
      </ContentContainer>
    </Container>
  );
};
